<template>

</template>

<script>

    import {Tabs, Tab} from 'vue-tabs-component';
    import card from 'components/cards/card.vue'

    export default {
        components: {
            'tabs': Tabs,
            'tab': Tab,
            'card': card
        },
        data() {
            return {};
        },
        mounted() {

        },
        methods: {
            selectTab(tabHash){
                this.$refs.tabsComponent.selectTab(tabHash)
            }
        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" type="text/css">
    .tabs-component-tabs {
        display: flex;
        flex-wrap: wrap;
        border-bottom: 1px solid theme('colors.black');
    }

    .tabs-component-tab {

        padding-right: 20px;
        transition: color 0.2s ease-in-out;

        @screen md {
            width:112px;
        }

        padding-bottom: 10px;

        &.is-active {
            & .tabs-component-tab-a {
                border-bottom: 3px solid theme('colors.primarycolor');
                color: theme('colors.primarycolor');
            }
        }
        &:hover {
            color: theme('colors.primarycolor');
        }
    }

    .tabs-component-tab-a {
        padding-bottom: 10px;
    }

    .tabs-component-panels {
        background: theme('colors.verylightpink');
        padding-bottom:90px;
        @apply mt-10;

        @apply -mx-7;

        @screen md {
            @apply -mx-4;
        }
        @screen xl {
            @apply -mx-9;
        }
    }

    .tabs-component-panel {

        @apply pt-6;
        @apply px-4;
        @screen xl {
            @apply px-9;
        }
    }


    .date-col-fixed {
        width:128px;
    }


</style>
